import { render, staticRenderFns } from "./NavPaging.vue?vue&type=template&id=7d3c5072"
import script from "./NavPaging.vue?vue&type=script&lang=js"
export * from "./NavPaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports